import {
  all,
  call,
  put,
  select,
  takeEvery,
} from 'redux-saga/effects';

import {
  listingApi,
} from '../../api';
import {
  errorHandler, successHandler,
} from '../../libs/ga';
import {
  cloneDeep,
  forEach,
} from '../../libs/lodash';

import {
  WAREHOUSE,
} from './constants';

function* storeWarehouse(data = {}, merge = true) {
  yield put({
    type: WAREHOUSE.update,
    data,
    merge,
  });
}

function* fetchWarehouse({
  data,
}) {
  yield* storeWarehouse(data);
}

function* updateWarehouse({
  data, onSuccess,
}) {
  try {
    const {
      _id,
      ...rest
    } = data;
    let id = _id;
    if (_id) {
      yield call(() => new Promise((resolve, reject) => {
        listingApi.update({
          collection: 'warehouse',
          payload: {
            _id,
            data: rest,
          },
        }).then(() => resolve(true))
          .catch((error) => reject(error));
      }));
      yield* storeWarehouse({
        [data._id]: data,
      });
    } else {
      const {
        newData,
      } = yield call(() => new Promise((resolve, reject) => {
        listingApi.create({
          collection: 'warehouse',
          payload: {
            data,
          },
        }).then((res) => resolve(res.data))
          .catch((err) => reject(err));
      }));
      id = newData._id;
      yield* storeWarehouse({
        [newData._id]: newData,
      });
    }
    successHandler('Thành công', 'Cập nhật thành công', onSuccess(id));
  } catch (error) {
    yield* storeWarehouse();
    errorHandler('Thất bại', error);
  }
}

function* removeWarehouse({
  _id,
}) {
  const {
    warehouse,
  } = yield select();
  try {
    yield call(() => new Promise((resolve, reject) => {
      listingApi.remove({
        collection: 'warehouse',
        payload: {
          _id,
        },
      }).then(() => resolve(true))
        .catch((error) => reject(error));
    }));

    const newData = cloneDeep(warehouse.data);
    delete newData[_id];
    yield* storeWarehouse(newData, false);

    successHandler('Thành công', 'Xóa thành công');
  } catch (error) {
    yield* storeWarehouse();
    errorHandler('Thất bại', error);
  }
}

function* importWarehouse({
  data = [],
}) {
  yield call(() => new Promise((resolve, reject) => {
    listingApi.importData({
      collection: 'warehouse',
      payload: {
        data,
      },
    }).then(() => resolve(true))
      .catch((err) => reject(err));
  }));
  const {
    warehouse,
  } = yield select();
  const newData = cloneDeep(warehouse.data);
  forEach(
    (obj) => {
      newData[obj._id] = obj;
    },
    data,
  );
  yield* storeWarehouse(newData);
  successHandler('Thành công', 'Cập nhật thành công');
}

export default function* warehouseSaga() {
  yield all([
    yield takeEvery(WAREHOUSE.handlers.fetch, fetchWarehouse),
    yield takeEvery(WAREHOUSE.handlers.import, importWarehouse),
    yield takeEvery(WAREHOUSE.handlers.update, updateWarehouse),
    yield takeEvery(WAREHOUSE.handlers.remove, removeWarehouse),
  ]);
}
